export const toolTypeRouteMap = new Map<string, string>([
	['OilSeparator', 'oil-separator-calculation'],
	['PressureSafetyValve', 'pressure-safety-valve'],
]);
